<template>
  <div class="two-factor-link-verification-failure">
    <img
      alt="Green badge with white checkmark"
      loading="lazy"
      height="45px"
      width="45px"
      src="@/assets/images/red-warning-triangle.svg"
    >
    <header
      class="two-factor-link-verification-failure-header"
    >
      The link could not be verified
    </header>
    <p class="two-factor-link-verification-failure-text">
      Please close this tab and click “Resend Link” within the
      Official USPS® Change-of-Address form to request a new link.
    </p>
  </div>
</template>

<script>
import pageName from '../../utils/pageName';
import { getPageProperties, getContext } from '../../utils/analyticsHelpers';

export default {
  name: 'VerificationFailure',
  async mounted() {
    this.$store.commit('DISABLE_LOADER');
    window.analytics.page(pageName, getPageProperties(this.$route), getContext());
  },
};
</script>
<style>
.two-factor-link-verification-failure {
  margin: auto;
  padding: 120px 20px 200px 20px;
  max-width: 446px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
}
.two-factor-link-verification-failure-header {
  padding: 10px 0 20px 0;
  color: var(--usps-digital-red);
  font-weight: 700;
  font-size: 1.25em;
}
.two-factor-link-verification-failure-text {
  text-align: center;
}
</style>
